import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generatePath } from 'react-router-dom';
import {
  API_ASSET_MAPING_CONFIG_GET_LIST,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_ASSET_MAPPING_CONFIG,
} from '../constants';

const api = ({ solutionId, siteId, twinId }) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_ASSET_MAPING_CONFIG_GET_LIST, {
      solutionId,
      siteId,
      twinId,
    }),
  });

const assetMappingConfig = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_ASSET_MAPPING_CONFIG,
  responseMapping: ResponseMapping.Default,
});

export default assetMappingConfig;
